import type { BusinessCatalogItem } from '~/api/graphql/generated/types'
import i18n from '~/locales/i18n'

export const getInventoryItemDisplayName = (
  inventoryItem:
    | Pick<BusinessCatalogItem, 'name' | 'variation'>
    | null
    | undefined,
): string => {
  if (!inventoryItem) {
    return ''
  }

  return [
    inventoryItem.name?.trim(),
    inventoryItem.variation?.composedName?.trim(),
  ]
    .filter(Boolean)
    .join(' | ')
}

export const getInventoryItemDisplayQuantity = ({
  orderedQuantity,
  perPackageAmount,
  productSizeUnit,
  packageType,
}: {
  orderedQuantity: number
  packageType: string
  perPackageAmount: number
  productSizeUnit: string
}): { breakdown: string; total: string } => {
  const total = `${orderedQuantity * perPackageAmount} ${productSizeUnit}`

  const breakdown = i18n.t(
    'Admin:CATALOG.ORDERS.ORDER_ITEM_QUANTITY_BREAKDOWN',
    {
      quantity: orderedQuantity,
      packageType,
      amount: perPackageAmount,
      unit: productSizeUnit,
    },
  )

  return { total, breakdown }
}
